import { useLocalStorage } from 'usehooks-ts';

export const useLocalStorageGeolocation = () => {
    return useLocalStorage('ahs-my-geolocation', { initializeWithValue: '' });
};
